import { isGoogleCrawler } from '../../utils'

const renderAlbum = ({ is_free, rank, play_count, album_id, album, pk }, linkTo) => {
  const {
    version,
    category,
    cover_image,
    pub_date,
    link,
    small_cover_image,
    hash,
    name,
    description,
    author,
    ready,
    age_group,
    age_group_text,
    language,
    language_abbrivation,
  } = album.fields
  const isProUser = window.IS_SUBSCRIBED || document.body.classList.contains('proUser')
  const albumLink = linkTo ? linkTo : link
  const albumRel = 'url'
  const gameDeepLink = ready !== 4 ? `${window.url_scheme}album/${pk}` : window.websaleLink

  const gameClickEvent = (clickedElement) => {
    const eventData = `{ clickedElement: '${clickedElement}', suggestedGameId:  '${album_id}', isPremium: '${!is_free}' , isProUser: '${isProUser}' }`
    return `sendGA4Event('suggested_game_click', ${eventData}); ${`window.handleGameClick('${gameDeepLink}', '${link}');`} `
  }
  const authorClickEvent = () => {
    const eventData = `{ suggestedGameId:  '${album_id}', suggestedAuthor: '${
      author.username
    }', isPremium: '${!is_free}', isProUser: '${isProUser}' }`
    return `sendGA4Event('suggested_author_click', ${eventData});`
  }

  return `<div class="bookshelfItem">
    <div id="album_${album_id}" class="albumBox">
        <div class="gameCover" id='album_${hash}' class='albumBox' rel="${name}">
            <div class="albumImage">
                <a rel="" href="${link}" onclick="${gameClickEvent('album_cover')}">
                    <img importance="high" data-original='${small_cover_image}' width="154" height="117"
                    alt="Play ${name} by ${
    author.first_name ? `${author.first_name} ${author.last_name}` : 'TinyTap creator'
  } online"
                        src='${small_cover_image}'  
                        onerror="if (this.src != '${cover_image}') this.src = '${cover_image}';"/>
                </a>
            </div>
            <div class="albumDetails"  data-lang-id="${language}" data-lang-abbreviation="${language_abbrivation}" data-age-group-id="${age_group}" data-age-group="${age_group_text}">
                <p class="gameTitle">
                    <a rel="${albumRel}" href="${link}" onclick="${gameClickEvent('album_name')}">
                        ${name}${!!description ? ` - ${description}` : ''}
                    </a>
                </p>
                <p class="authorTitle">
                    <a href="/community/profile/${
                      author.username
                    }/" class="profileLink" onclick="${authorClickEvent()}" title="Educational learning games by ${
    author.first_name
  } ${author.last_name}">
                        ${author.first_name} ${author.last_name}
                    </a>
                </p>
                ${play_count > 50 ? `<p class="playCount">${play_count.toLocaleString()} ${trans('plays')}</p>` : ''}
                ${
                  !is_free
                    ? `<p class="premium">
                    <span class="if if-crown"></span> <span class="premium-text">${trans('Premium')}</span>
                </p>`
                    : ''
                }
            </div>
        </div>
    </div>
</div>`
}

export const loadSideSuggestions = async (count, albumId) => {
  // albumStoreId is rendered to the template
  const ALBUM_COUNT = count || 12
  let albums
  if (window.relatedAlbums) {
    albums = window.relatedAlbums
  } else {
    const id = albumStoreId || albumId
    const response = await fetch(`/store/api/album/${id}/related/?count=${ALBUM_COUNT}`).then((r) => r.json())
    if (response.result != 'success') {
      console.error(response.data)
      return
    }
    albums = response.data.albums
  }

  const appStorePageLink =
    window.websaleLink ||
    window.appleAppStore ||
    window.googleAppStore ||
    '/store/landing_page/?utm_campaign=from_mobile_web_page'

  if (albums && albums.length) {
    const relatedLoader = document.getElementById('relatedLoader')
    const relatedContainer = document.querySelector('.relatedContainer')
    const addedAlbumsHtml = albums.map((album) => renderAlbum(album, appStorePageLink))

    if (!isGoogleCrawler()) {
      const pushXGames = 0 // 2
      const googleAdsElement = document.querySelector('.google_ads_container')
      if (googleAdsElement) {
        var google_adsHtml = googleAdsElement.outerHTML
        addedAlbumsHtml.splice(pushXGames, 0, google_adsHtml)
        googleAdsElement.remove()
      }
    }
    relatedLoader.parentNode.removeChild(relatedLoader)
    relatedContainer.innerHTML = addedAlbumsHtml.join('\n')
  }
}

